﻿var _wamp_socket = require('../config/config').WampConfig

module.exports = _wamp_socket;